import { FC, useContext } from 'react';
import { QuestionIcon } from '@phosphor-icons/react';
import { InfoDrawerContext } from '../../providers/InfoDrawer';
import { IPageGuideKey } from '../../constants/pageGuides';
import styles from './PageHelpButton.module.scss';

interface IPageHelpButtonProps {
  /** Chiave della guida di pagina in PAGE_GUIDES (es. 'page-readiness'). */
  pageKey: IPageGuideKey;
  /** Testo del bottone e aria-label; default «Come funziona questa pagina». */
  label?: string;
}

/**
 * Bottone «Come funziona questa pagina» che apre nell'InfoDrawer la guida
 * onnicomprensiva della pagina corrente (intro + tutte le metriche). Fratello
 * di InfoButton (che apre la singola metrica): stesso drawer, stesso context,
 * ma prominente e in testa alla pagina.
 */
const PageHelpButton: FC<IPageHelpButtonProps> = ({ pageKey, label }) => {
  const { setState } = useContext(InfoDrawerContext);
  const text = label ?? 'Come funziona questa pagina';

  return (
    <button
      type="button"
      className={styles.btn}
      onClick={() => setState(pageKey)}
      aria-label={text}
      title={text}
    >
      <QuestionIcon size={16} weight="bold" aria-hidden />
      <span>{text}</span>
    </button>
  );
};

export default PageHelpButton;
